// extracted by mini-css-extract-plugin
export default {"content":"styles_content__ETY8d"};